import Grid from '@mui/material/Grid2';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { useState } from 'react';
import PropTypes from 'prop-types';
import "./EGAutocomplete.scss";

const EGAutocomplete = ({
  label = '',
  initialValue = null,
  options = [],
  callback = (props = {}) => console.log(props),
  tag = '',
  errorMessage = '',
  margin = 0,
  freeSolo = false,
  value: externalValue,
  onChange: externalOnChange,
}) => {
  const [internalValue, setInternalValue] = useState(initialValue || null);

  const isControlled = externalValue !== undefined;
  const value = isControlled ? externalValue : internalValue;

  const handleChange = (_, newValue) => {
    if (!isControlled) {
      setInternalValue(newValue);
    }
    if (externalOnChange) {
      externalOnChange(newValue);
    } else {
      callback({ listElement: newValue });
    }
  };

  return (
    <Autocomplete
      id={`${tag}-egautocomplete`}
      options={options}
      getOptionLabel={(option) => {
        // Si freeSolo está habilitado, el valor puede ser una string simple
        if (typeof option === 'string') {
          return option;
        }
        return option.label || '';
      }}
      value={value}
      onChange={handleChange}
      freeSolo={freeSolo}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          error={!!errorMessage}
          helperText={errorMessage}
        />
      )}
      sx={{ padding: '0', margin }}
    />
  );
};

EGAutocomplete.propTypes = {
  label: PropTypes.string,
  initialValue: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  options: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.object])),
  callback: PropTypes.func,
  tag: PropTypes.string,
  errorMessage: PropTypes.string,
  margin: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  freeSolo: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onChange: PropTypes.func,
};

export default EGAutocomplete;
